var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 1.08252C8.18571 1.08252 6.41343 1.62014 4.90597 2.62738C3.39852 3.63463 2.22361 5.06627 1.52981 6.74125C0.836003 8.41624 0.654472 10.2594 1.00817 12.0375C1.36187 13.8157 2.23491 15.449 3.51689 16.731C4.79887 18.013 6.43221 18.886 8.21037 19.2397C9.98853 19.5934 11.8316 19.4119 13.5066 18.7181C15.1816 18.0243 16.6133 16.8494 17.6205 15.3419C18.6278 13.8345 19.1654 12.0622 19.1654 10.2492C19.1654 7.81804 18.1996 5.48646 16.4805 3.76737C14.7614 2.04829 12.4299 1.08252 9.9987 1.08252ZM14.7545 8.33835L8.9212 14.1717C8.76493 14.3279 8.55301 14.4157 8.33204 14.4157C8.11106 14.4157 7.89914 14.3279 7.74287 14.1717L5.24287 11.6717C5.09107 11.5145 5.00707 11.304 5.00897 11.0855C5.01087 10.867 5.09851 10.658 5.25302 10.5035C5.40753 10.349 5.61654 10.2614 5.83503 10.2595C6.05353 10.2576 6.26403 10.3416 6.4212 10.4934L8.33204 12.4042L13.5762 7.16002C13.7334 7.00822 13.9439 6.92423 14.1624 6.92612C14.3809 6.92802 14.5899 7.01566 14.7444 7.17017C14.8989 7.32468 14.9865 7.53369 14.9884 7.75219C14.9903 7.97068 14.9063 8.18118 14.7545 8.33835Z",
    fill: "#007F58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tickIcon.f4da84631f42a1d3b369156fdf099691.svg";
export { ForwardRef as ReactComponent };